module.exports = __webpack_public_path__ + "static/media/joD.c320374e.jpg";